import { useEffect, useState } from 'react'
import { serverNow } from './store'

/** The account host's time, ticking every `every` milliseconds while mounted. */
export function useNow(every = 1000): number {
  const [now, setNow] = useState(serverNow)
  useEffect(() => {
    const t = setInterval(() => setNow(serverNow()), every)
    return () => clearInterval(t)
  }, [every])
  return now
}
